export default function() {
    if (!this.isScreenMobile) {
        return this.$t("popupCard.computed.addImageText.attach");
    } else {
        return this.$t("popupCard.computed.addImageText.make");
    }
}
